const COMPARE_TYPE = {
  WEBSITES_ONLY: "websites_only",
  INFRASTRUCTURE_ONLY: "infrastructure_only",
  INTERNAL_INFRASTRUCTURE_ONLY: "internal_infrastructure_only",
  AI_SERVICES_ONLY: "ai_services_only",
  ASSETS: "assets",
  MIXED: "mixed",
}

const METABASE_ALIAS = {
  WEBSITES: "compare_websites",
  INFRASTRUCTURE: "compare_infra",
  INTERNAL_INFRASTRUCTURE: "compare_internal_infra",
  ASSETS: "compare_assets",
  AI_SERVICES: "compare_ai_services",
}

/**
 * Determines the comparison type based on the nodes
 * @param {Array} comparedNodes - Array of nodes to compare
 * @returns {string} The comparison type (websites_only, infrastructure_only, assets, IA or mixed)
 */
export const getCompareType = (comparedNodes) => {
  if (!comparedNodes || comparedNodes.length === 0) {
    return COMPARE_TYPE.MIXED
  }

  const hasAllWebsitesOnly = comparedNodes.every(
    (node) => node.has_websites_only
  )
  if (hasAllWebsitesOnly) {
    return COMPARE_TYPE.WEBSITES_ONLY
  }

  const hasAllInternalInfrastructureOnly = comparedNodes.every(
    (node) => node.has_internal_infrastructure_equipment_only
  )
  if (hasAllInternalInfrastructureOnly) {
    return COMPARE_TYPE.INTERNAL_INFRASTRUCTURE_ONLY
  }

  const hasAllInfrastructureOnly = comparedNodes.every(
    (node) => node.has_infrastructure_equipment_only
  )
  if (hasAllInfrastructureOnly) {
    return COMPARE_TYPE.INFRASTRUCTURE_ONLY
  }

  const hasAllAiServicesOnly = comparedNodes.every(
    (node) => node.has_ai_services_only
  )
  if (hasAllAiServicesOnly) {
    return COMPARE_TYPE.AI_SERVICES_ONLY
  }

  const hasAllAssets = comparedNodes.every((node) => node.has_equipment_only)
  if (hasAllAssets) {
    return COMPARE_TYPE.ASSETS
  }

  return COMPARE_TYPE.MIXED
}

/**
 * Determines if Metabase approach should be used
 * @param {Array} comparedNodes - Array of nodes to compare
 * @returns {boolean} True if Metabase should be used, false otherwise
 */
export const shouldUseMetabaseApproach = (comparedNodes) => {
  const compareType = getCompareType(comparedNodes)
  return compareType !== COMPARE_TYPE.MIXED
}

/**
 * Gets the Metabase alias based on the comparison type
 * @param {Array} comparedNodes - Array of nodes to compare
 * @returns {string} The Metabase alias to use
 */
export const getMetabaseAlias = (comparedNodes) => {
  const compareType = getCompareType(comparedNodes)

  switch (compareType) {
    case COMPARE_TYPE.WEBSITES_ONLY:
      return METABASE_ALIAS.WEBSITES
    case COMPARE_TYPE.INTERNAL_INFRASTRUCTURE_ONLY:
      return METABASE_ALIAS.INTERNAL_INFRASTRUCTURE
    case COMPARE_TYPE.INFRASTRUCTURE_ONLY:
      return METABASE_ALIAS.INFRASTRUCTURE
    case COMPARE_TYPE.AI_SERVICES_ONLY:
      return METABASE_ALIAS.AI_SERVICES
    case COMPARE_TYPE.ASSETS:
    default:
      return METABASE_ALIAS.ASSETS
  }
}

export { COMPARE_TYPE, METABASE_ALIAS }
